// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Navbar_wrapper__2rzOi","navbarContent":"Navbar_navbarContent__2haS_","logo":"Navbar_logo__2hju6","links":"Navbar_links__1l4ZZ"};